
import { T } from '@angular/cdk/keycodes';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
//import * as ace from "ace-builds";
import * as ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/mode-typescript';
import 'ace-builds/src-noconflict/mode-csharp';
import 'ace-builds/src-noconflict/theme-monokai'; 
import { HTTPService } from 'src/app/services/http.service';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { Variable } from 'src/app/forms/formula-tester/formula-tester.component';

@Component({
  selector: 'code-editor',
  templateUrl: './code-editor.component.html',
  styleUrls: ['./code-editor.component.scss'],
  standalone: false
})
export class CodeEditorComponent implements AfterViewInit, OnChanges {
    useWrapMode: boolean = false;
    useSoftTabs: boolean = false;
    highlightActiveLine:boolean = true;
    tabSize:number = 2;
    showPrintMargin: boolean = false;
    
  
    constructor(private http:HTTPService, private _changeDetectorRef: ChangeDetectorRef){

    }
  
    ngOnChanges(changes: SimpleChanges): void {
       if (!this.isInitialized || !changes['code']) return;

        const newValue = changes['code'].currentValue;
        const currentValue = this.aceEditor.getSession().getValue();

        if (newValue !== currentValue) {
          this.aceEditor.getSession().setValue(newValue, -1); // avoids selection
        }

    }
    
    @ViewChild('logContainer') logContainer!: ElementRef<HTMLPreElement>;

    @ViewChild('editor', { static: false }) editorRef!: ElementRef;
    @Output()codeChange:EventEmitter<any> = new EventEmitter<any>();
    @Input() readOnly:boolean = true;
    @Input() code: any = '';
    @Input() mode:string='java';
    @Input()height:string='350px';
    @Input()leftSize = "70%";
    @Input()rightSize = "30%";
    @Input() variables:Variable[] = [];
    inputValue:string = '';
    aceEditor:any;
    showConsole:boolean = false;
    isInitialized = false;
    buttonLoading = false;
    ngAfterViewInit(): void {
        this.mode = this.mode.toLowerCase();
        this.aceEditor = ace.edit(this.editorRef.nativeElement);
      
        // ace.config.set('basePath', 'assets/ace');
        // ace.config.setModuleUrl('ace/mode/'+this.mode+'_worker', 'assets/ace/worker-'+this.mode+'.js');
        // ace.config.setModuleUrl('ace/theme/github', 'assets/ace/github.js');

        this.aceEditor.setTheme('ace/theme/github');
        //this.aceEditor.session.setMode('ace/mode/json');
        this.aceEditor.session.setMode('ace/mode/'+this.mode);
        this.aceEditor.session.setTabSize(this.tabSize);
        this.aceEditor.session.setValue(this.code);
        this.aceEditor.session.setUseWrapMode(this.useWrapMode);
        this.aceEditor.session.setUseSoftTabs(this.useSoftTabs);

        this.aceEditor.setOptions({
            fontSize: '14px',
            showPrintMargin: this.showPrintMargin,
            highlightActiveLine: this.highlightActiveLine,
            showGutter: true,
            readOnly: this.readOnly,

        });

        this.isInitialized = true;

        if ( this.readOnly != null ){
          this.aceEditor.session.on('change', (delta) => {
            try {
              let newContent = this.aceEditor.session.getValue();
              this.code = newContent;
              this.codeChange.emit(this.code);
            }catch(Exception){

            }
          });
        }
    }

    testCode(){

      let ob = {
          type: this.mode.toUpperCase(),
          code: this.code,
          variables: this.variables
      }
      this.buttonLoading = true;
      return new Promise((resolve, reject)=>{
        this.http.post(ob,'FlowServices/testCode',false,true,true).subscribe({
            next:  (data)=>{
              if ( this.inputValue!='' ){
                this.inputValue= this.inputValue+ "\n"
              }
              
              if ( data['console']!=null && data['console']!=''){
                  this.inputValue = this.inputValue+ "\n" + "["+new Date(Date.now()).toISOString()+"][LOG]: "+  data['console'];
              }
              if ( data['result']!=null){
                  this.inputValue = this.inputValue+ "\n" + "["+new Date(Date.now()).toISOString()+"][RESULT]: "+ data['result'];
              }
              
              this.buttonLoading = false;
              this._changeDetectorRef.detectChanges();
              this.scrollToBottom();
              resolve(true);
              
              
            },
            error: (error)=>{
                resolve(true);
                this.buttonLoading = false;
                this._changeDetectorRef.detectChanges();
                
                GlobalErrorHandler.showError(error);
                
            },
            complete:()=> {this.buttonLoading = false;}
        });
      });
      
    }


    private scrollToBottom(): void {
      const el = this.logContainer?.nativeElement;
      if (el) {
        el.scrollTo({ top:  el.scrollHeight+ + 44, behavior: 'smooth' });
      }
    }

}